import { ModelBase, NeoModel } from "@singularsystems/neo-core";

@NeoModel
export default class AuthorisableUpdateRequestLookup extends ModelBase {
  public authorisableUpdateRequestBatchId: number = 0;
  
  public authorisableUpdateTableRequestId: number = 0;

  public tableName: string = "";

  public additionalInfo: string = "";

  public notes: string = "";
  
  public primaryKeyId: number = 0;
  
  public fieldName: string = "";
  
  public oldValue: string ="";
  
  public newValue: string = "";
}